import React from 'react';
export function Footer() {
  return <footer className="bg-white border-t border-gray-100 py-12 px-4 sm:px-6 lg:px-8" data-id="element-66">
      <div className="max-w-7xl mx-auto flex flex-col items-center text-center" data-id="element-67">
        <div className="w-10 h-10 bg-navy rounded-lg flex items-center justify-center mb-4" data-id="element-68">
          <span className="text-white font-bold text-xl leading-none" data-id="element-69">EE</span>
        </div>
        <h4 className="font-bold text-navy text-xl mb-2" data-id="element-70">
          Entrevistas Espectaculares
        </h4>
        <p className="text-gray-500 mb-8" data-id="element-71">
          El Método de la Conversación Estratégica
        </p>

        <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-400 mb-8" data-id="element-72">
          <a href="#" className="hover:text-navy transition-colors" data-id="element-73">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-navy transition-colors" data-id="element-74">
            Política de Privacidad
          </a>
          <a href="#" className="hover:text-navy transition-colors" data-id="element-75">
            Contacto
          </a>
        </div>

        <p className="text-sm text-gray-400" data-id="element-76">
          © 2026 Entrevistas Espectaculares. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}